import { BaseEditor } from "slate";
import { HistoryEditor } from "slate-history";
import { ReactEditor } from "slate-react";

export enum TextAction {
  Bold = 'bold',
  Italics = 'italic',
  Underline = 'underline',
  Strikethrough = 'strikethrough',
  Superscript = 'superscript',
  Subscript = 'subscript',
  Highlight = 'highlight',
  Code = 'code',
  LeftAlign = 'left',
  CenterAlign = 'center',
  RightAlign = 'right',
  JustifyAlign = 'justify',
  Divider = 'divider',
  BlockQuote = 'block-quote',
  NumberedList = 'numbered-list',
  BulletedList = 'bulleted-list',
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  H6 = 'h6',
  Undo = 'undo',
  Redo = 'redo',
  Image = 'image',
  Link = 'link',
}

export type EditorType = BaseEditor & ReactEditor & HistoryEditor;
export type CustomText = {
  text: string;
  bold?: boolean;
  underline?: boolean;
  superscript?: boolean;
  subscript?: boolean;
  italic?: boolean;
  code?: boolean;
  highlight?: boolean;
  strikethrough?: boolean;
};

export const HEADING_TYPES = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
export type HeadingKey = typeof HEADING_TYPES[number];

export const LIST_TYPES = ['numbered-list', 'bulleted-list'];
export type ListTypeKey = typeof LIST_TYPES[number];

export const TEXT_ALIGN_TYPES = ['left', 'center', 'right', 'justify'];
export type AlignKey = typeof TEXT_ALIGN_TYPES[number];

export const TEXT_FORMAT_TYPES = ['bold', 'underline', 'superscript', 'subscript', 'italic', 'code', 'highlight', 'strikethrough'];
export type TextFormatType = typeof TEXT_FORMAT_TYPES[number];
export type TextFormatKey = keyof Omit<CustomText, 'text'>;

export const SELECTION_PROPS = { colorScheme: "blue", variant: "solid" }



//export type HeadingKey = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
//export type AlignKey = "left" | "right" | "center" | "justify";

export type CustomElement = {
  type: string;
  children: CustomText[];
  align?: AlignKey;
  url?: string
  target?: string
};

// export type MarkKey =
//   | "bold"
//   | "underline"
//   | "superscript"
//   | "subscript"
//   | "italic"
//   | "code"
//   | "highlight"
//   | "strikethrough";
export type MarkKey =
  | TextFormatKey;


export type ElementKey =
  | AlignKey
  | HeadingKey
  | 'block-quote'
  | ListTypeKey
  | 'list-item'
  | 'link';

  declare module 'slate' {
    interface CustomTypes {
      Editor: EditorType
      Element: CustomElement
      Text: CustomText
    }
  }